<div class="container-fluid px-0" *ngIf="paymentResult !== null">
  <div class="row my-0 mx-0">
    <div class="col-12 px-0 d-flex justify-content-center">
      <img class="timeout-logo" [src]="'assets/images/png/timeout.png'" [srcset]="'assets/images/png/timeout@2x.png 2x, assets/images/png/timeout@3x.png 3x'" alt="logo"></div>
    <div class="col-12 px-0 d-flex justify-content-center"><label
      class="timeout-header">{{paymentResult?.message}}</label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center"><label
      class="timeout-message">{{paymentResult?.amount}}</label></div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="path"></div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <label class="router-message">
        <label class="router">
          <nz-countdown [nzValue]="deadline" (nzCountdownFinish)="stop()" [nzFormat]="'ss'"></nz-countdown>
        </label>
        {{this.textService.keyValueMapping('returnUrlSecond', 'saniye içinde', paymentResult.sdkInitTexts)}} {{redirectToSiteName}}
        {{this.textService.keyValueMapping('returnUrlText', '’a yönlendirileceksiniz.', paymentResult.sdkInitTexts)}}
      </label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <p><label class="router-link"><a
        (click)="stop()">{{this.textService.keyValueMapping('goToSiteButton', 'Siteye git', paymentResult.sdkInitTexts)}}</a></label>
      </p>
    </div>
  </div>
</div>

